import { gql } from "@apollo/client";

export const UPDATE_INVOICE_ROWS = gql`
  mutation updateInvoiceRows($input: UpdateInvoiceRowsInput!) {
    invoice {
      updateInvoiceRows(input: $input) {
        success
      }
    }
  }
`;
